import { render, staticRenderFns } from "./ReinscripcionPage.vue?vue&type=template&id=f6e18a3a&scoped=true&"
import script from "./ReinscripcionPage.vue?vue&type=script&lang=js&"
export * from "./ReinscripcionPage.vue?vue&type=script&lang=js&"
import style0 from "./ReinscripcionPage.vue?vue&type=style&index=0&id=f6e18a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e18a3a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/inscripciones/ReinscripcionPage.vue
// module id = 224
// module chunks = 4